import { useEffect } from "react";
import { useLocation } from "@remix-run/react";

export default function useGTMPageView() {
    const location = useLocation();

    useEffect(() => {
        if (window.dataLayer) {
            // Read store from cookie (can't use useStore - hook runs outside StoreProvider)
            const cookieStore = document.cookie
                .split('; ')
                .find(c => c.startsWith('selectedStore='))
                ?.split('=')[1];
            const dispensaryId = cookieStore ? decodeURIComponent(cookieStore) : '';

            window.dataLayer.push({
                event: "pageview",
                page: {
                    path: location.pathname,
                    search: location.search,
                    url: location.pathname + location.search,
                },
                dispensary_id: dispensaryId,
            });

            if (dispensaryId) {
                window.dataLayer.push({
                    event: 'dispensaryLocationSet',
                    dispensary_id: dispensaryId,
                });
            }
        }
    }, [location]);
}